
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wishlists",
      function () {
        return require("private-next-pages/wishlists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wishlists"])
      });
    }
  